// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._4t3i1vuk{height:90%}", ""]);
// Exports
module.exports = exports;
